import React from 'react';
import { Link as RRLink } from 'react-router-dom';
import { useTheme } from '@mui/material';
import { Flex } from '../Flex';
import { AbstractButton } from '../AbstractButton';
import { Card } from '../Card';
import { Popover, PopoverContent, PopoverTrigger } from '../Popover';
import { BreadcrumbItem } from './Breadcrumbs';
import { Link } from '../Link';

interface CollapsedBreadcrumbsProps {
  /**
   * The items that have been collapsed and should appear in the popover
   */
  crumbs: BreadcrumbItem[];
}

/**
 * Custom collapsed icon component for MUI Breadcrumbs.
 * Renders a "..." button that opens a popover with the collapsed breadcrumb items.
 * This component is used as the CollapsedIcon slot in MUI Breadcrumbs.
 */
const CollapsedBreadcrumbs: React.FC<CollapsedBreadcrumbsProps> = ({ crumbs }) => {
  const theme = useTheme();
  const componentTokens = theme.palette?.componentTokens;

  return (
    <Popover>
      <PopoverTrigger
        as={AbstractButton}
        padding={0}
        height="auto"
        aria-label="Toggle additional breadcrumbs"
      >
        ...
      </PopoverTrigger>
      <PopoverContent alignment="bottom-right">
        <Card
          as="ul"
          my={1}
          px={5}
          pt={5}
          shadow="dark300"
          minWidth={180}
          sx={{
            border: `1px solid ${componentTokens?.selectMenuItems.color.item.stroke.container.resting}`,
          }}
        >
          {crumbs.map(crumb => {
            return (
              <Flex key={crumb.href} as="li" alignItems="center">
                {/* TODO: Add border on element, maybe wrap link in abstract button w/ border to match Dropdown component behavior */}
                <Link
                  as={RRLink}
                  to={crumb.href}
                  variant="neutral"
                  truncated
                  maxWidth="450px"
                  pb={5}
                  fontSize="medium"
                  sx={{
                    border: 'none !important',
                  }}
                >
                  {crumb.children}
                </Link>
              </Flex>
            );
          })}
        </Card>
      </PopoverContent>
    </Popover>
  );
};

export default CollapsedBreadcrumbs;
